/* Product-card titles always fit on ONE line (owner call 2026-07-24):
 * shrink the font from its styled size down to a floor, then let
 * text-overflow: ellipsis take the rare leftover. Re-runs when the shop
 * grid re-renders (filters/sort AJAX) via a childList observer. */
(function () {
  'use strict';
  var MIN_PX = 11;

  function fit(el) {
    if (!el || !el.isConnected) return;
    // Reset any previous shrink so re-measures start from the styled size.
    el.style.fontSize = '';
    var base = parseFloat(getComputedStyle(el).fontSize) || 14;
    var size = base;
    while (size > MIN_PX && el.scrollWidth > el.clientWidth) {
      size -= 0.5;
      el.style.fontSize = size + 'px';
    }
  }

  function fitAll(root) {
    (root || document).querySelectorAll('.home-shop__product-title').forEach(fit);
  }

  var scheduled = null;
  function schedule() {
    clearTimeout(scheduled);
    scheduled = setTimeout(function () { fitAll(); }, 60);
  }

  function init() {
    fitAll();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
    window.addEventListener('resize', schedule);
    ['.shop-all__grid', '.shop-all__featured', '.home-shop__rail-track', '.home-shop__tiles'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (host) {
        new MutationObserver(schedule).observe(host, { childList: true, subtree: true });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
